import { useMemo } from 'react';
import { useContainer } from 'src/features/ioc';
import { EquitiesSymbolSearchServiceImpl } from 'src/services/SymbolSearchService/impl/equities';
import { OptionsSymbolSearchServiceImpl } from 'src/services/SymbolSearchService/impl/options';

export const useRecentlyUsedSymbolsService = () => {
    const reactContainer = useContainer();
    const recentlyUsedSymbolsService = reactContainer.get('RecentlyUsedSymbolsService');
    return recentlyUsedSymbolsService;
};

export const useOptionsSymbolSearchService = () => {
    const reactContainer = useContainer();
    const securityMasterService = reactContainer.get('SecurityMasterService');
    const queryClient = reactContainer.get('QueryClient');
    const optionsListService = reactContainer.get('OptionsListService');

    const symbolSearchService = useMemo(() => {
        return new OptionsSymbolSearchServiceImpl(securityMasterService, queryClient, optionsListService);
    }, [securityMasterService, queryClient, optionsListService]);

    return {
        symbolSearchService,
    };
};

export const useEquitiesSymbolSearchService = () => {
    const reactContainer = useContainer();
    const securityMasterService = reactContainer.get('SecurityMasterService');
    const queryClient = reactContainer.get('QueryClient');

    const equitiesSymbolSearchService = useMemo(() => {
        return new EquitiesSymbolSearchServiceImpl(securityMasterService, queryClient);
    }, [securityMasterService, queryClient]);

    return {
        symbolSearchService: equitiesSymbolSearchService,
    };
};
